import { PageHero, CTABand } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { GraduationCap, Award, Building } from "lucide-react";

const CLIENTS = ["Bloomberg", "Amazon", "Leidos", "Volkswagen", "Raytheon/RTX", "Capital One"];

export default function Leadership() {
  return (
    <main data-testid="leadership-page">
      <PageHero
        eyebrow="Leadership"
        title="Led by experience"
        subtitle="The people behind every precisely planned move."
      />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid lg:grid-cols-5 gap-14">
          <Reveal className="lg:col-span-2 relative">
            <div className="absolute -top-4 -left-4 w-24 h-24 border-t-4 border-l-4 border-brand" />
            <img
              src="/images/leadership.jpg"
              alt="Heather Harris, President and CEO of HLM Moving"
              data-testid="leadership-portrait"
              className="w-full aspect-[4/5] object-cover rounded-sm"
            />
            <div className="mt-6 bg-navy text-white p-6 rounded-sm">
              <p className="font-display font-bold text-xl">Heather Harris</p>
              <p className="text-brand text-xs font-bold uppercase tracking-[0.2em] mt-1">
                President &amp; Chief Executive Officer
              </p>
            </div>
          </Reveal>

          <div className="lg:col-span-3 space-y-8">
            <Reveal delay={0.1}>
              <p className="text-slate-600 leading-relaxed">
                As President and CEO of HLM Moving, Heather Harris leads the company's strategic direction,
                operations, and client partnerships. With deep experience across commercial relocation,
                workplace solutions, and facilities services, she has built HLM Moving into a trusted
                partner for organizations across the region.
              </p>
              <p className="text-slate-600 leading-relaxed mt-4">
                Heather is committed to a service-first culture where every move — from a single office to
                a full facility — is handled with the planning, care, and communication clients deserve.
              </p>
              <p className="text-slate-600 leading-relaxed mt-4">
                A recognized expert in corporate facilities, relocation, and client relations, Heather has
                a proven track record of providing innovative solutions to a variety of clients throughout
                her career. She has worked with Bloomberg, Amazon, Leidos, Volkswagen, and Raytheon/RTX.
              </p>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="flex items-center gap-3 mb-4">
                <Building size={18} className="text-brand" />
                <h3 className="font-display font-semibold text-lg text-navy">Client Experience</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {CLIENTS.map((c) => (
                  <span key={c} className="border border-slate-200 bg-white text-navy text-sm font-semibold px-4 py-2 rounded-sm">
                    {c}
                  </span>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.3}>
              <div className="flex items-center gap-3 mb-4">
                <GraduationCap size={18} className="text-brand" />
                <h3 className="font-display font-semibold text-lg text-navy">Education &amp; Honors</h3>
              </div>
              <ul className="space-y-3 text-sm text-slate-600">
                <li className="flex items-start gap-3">
                  <Award size={16} className="text-brand mt-0.5 shrink-0" />
                  Master of Architecture (M.Arch I), City College of New York
                </li>
                <li className="flex items-start gap-3">
                  <Award size={16} className="text-brand mt-0.5 shrink-0" />
                  Graduated Summa Cum Laude
                </li>
                <li className="flex items-start gap-3">
                  <Award size={16} className="text-brand mt-0.5 shrink-0" />
                  Member, Golden Key National Honor Society
                </li>
              </ul>
            </Reveal>
          </div>
        </div>
      </section>
      <CTABand />
    </main>
  );
}
